var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.25H8C4.83 2.25 2.25 4.83 2.25 8V16C2.25 19.17 4.83 21.75 8 21.75H16C19.17 21.75 21.75 19.17 21.75 16V8C21.75 4.83 19.17 2.25 16 2.25ZM20.25 16C20.25 18.34 18.34 20.25 16 20.25H8C5.66 20.25 3.75 18.34 3.75 16V8C3.75 5.66 5.66 3.75 8 3.75H16C18.34 3.75 20.25 5.66 20.25 8V16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4698 14L16.5598 14.91C16.2098 15.26 15.6698 15.28 15.2898 14.97L11.5098 11.82C10.6298 11.09 9.38978 11.06 8.47978 11.74L5.54978 13.94C5.21978 14.19 5.14978 14.66 5.39978 14.99C5.64978 15.32 6.11978 15.39 6.44978 15.14L9.37978 12.94C9.72978 12.68 10.2098 12.69 10.5498 12.97L14.3298 16.12C14.7898 16.5 15.3398 16.69 15.8898 16.69C16.5198 16.69 17.1398 16.45 17.6198 15.97L18.5298 15.06C18.8198 14.77 18.8198 14.29 18.5298 14C18.2398 13.71 17.7598 13.71 17.4698 14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.75C16.74 10.75 17.75 9.74 17.75 8.5C17.75 7.26 16.74 6.25 15.5 6.25C14.26 6.25 13.25 7.26 13.25 8.5C13.25 9.74 14.26 10.75 15.5 10.75ZM15.5 7.75C15.91 7.75 16.25 8.09 16.25 8.5C16.25 8.91 15.91 9.25 15.5 9.25C15.09 9.25 14.75 8.91 14.75 8.5C14.75 8.09 15.09 7.75 15.5 7.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add_image.dc1a15665a68ab8b7b75a148bad662c5.svg";
export { ForwardRef as ReactComponent };